import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import './Auth.css';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, pendingRental } = useAuth();
  const [error, setError] = useState('');
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleCallback = async () => {
      // Log full URL and all params for debugging
      console.log('AuthCallback - Full URL:', window.location.href);
      console.log('AuthCallback - All params:', Object.fromEntries(searchParams.entries()));

      const token = searchParams.get('token');
      const errorParam = searchParams.get('error');

      console.log('AuthCallback - Token received:', token ? token.substring(0, 20) + '...' : 'No');

      if (errorParam) {
        setError(decodeURIComponent(errorParam));
        setStatus('error');
        setTimeout(() => navigate('/auth'), 3000);
        return;
      }

      if (token) {
        try {
          // First, store the token temporarily to make authenticated requests
          localStorage.setItem('authToken', token);
          console.log('AuthCallback - Token stored in localStorage');

          // Fetch user data from API
          setStatus('fetching');
          const response = await api.get('/v1/users', true);
          console.log('AuthCallback - API response:', response);

          // Handle different response structures
          let userData = response;
          if (response?.data?.user) {
            userData = response.data.user;
          } else if (response?.data) {
            userData = response.data;
          } else if (response?.user) {
            userData = response.user;
          }

          console.log('AuthCallback - User data:', userData);

          // Store the token and user data
          login(userData, token);

          // Redirect based on pending rental
          if (pendingRental) {
            navigate('/services');
          } else {
            navigate('/');
          }
        } catch (err) {
          console.error('AuthCallback - Failed to fetch user data:', err);
          // Clean up the token if fetching user failed
          localStorage.removeItem('authToken');
          setError(err.message || 'Failed to complete authentication');
          setStatus('error');
          setTimeout(() => navigate('/auth'), 3000);
        }
      } else {
        setError('No authentication token received');
        setStatus('error');
        setTimeout(() => navigate('/auth'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, login, navigate, pendingRental]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-callback-card">
          {status === 'error' ? (
            <>
              <div className="callback-icon error">
                <span className="material-symbols-outlined">error</span>
              </div>
              <h2 className="callback-title">Authentication Failed</h2>
              <p className="callback-message">{error}</p>
              <p className="callback-redirect">Redirecting to login...</p>
            </>
          ) : (
            <>
              <div className="callback-spinner"></div>
              <h2 className="callback-title">
                {status === 'fetching' ? 'Loading Profile' : 'Completing Sign In'}
              </h2>
              <p className="callback-message">
                {status === 'fetching'
                  ? 'Fetching your account information...'
                  : 'Please wait while we complete your authentication...'}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
